import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './assets/styles/globalStyles.css';
import { MemoryRouter } from 'react-router-dom';
import Providers from './components/Providers.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import CookieConsentPortal from './components/common/cookies/CookieConsentPortal.jsx';
import disableConsoleLogs from './utils/disableConsoleLogs.js';
import { initSWAutoUpdate } from '@/utils/swUpdatePrompt';

const isProduction = import.meta.env.MODE === 'production';
if (isProduction) disableConsoleLogs();

initSWAutoUpdate();


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MemoryRouter>
      <Providers>
        <ErrorBoundary>
          <App />
          {isProduction && <CookieConsentPortal />}
        </ErrorBoundary>
      </Providers>
    </MemoryRouter>
  </React.StrictMode>,
);
